export default __webpack_public_path__ + "static/media/seleccionados_puebla.944abbb6.pdf";